import { getOpxHostApi } from 'owa-opx';
import { isHostAppFeatureEnabled } from 'owa-hostapp-feature-flags';
import { getBposPromise } from 'owa-bpos-store';
/* eslint-disable-next-line owa-custom-rules/forbid-empty-import-statements-from-modules -- (https://aka.ms/OWALintWiki)
 * Baseline. DO NOT COPY AND PASTE!, replace this line with a justification or fix the issue.
 *	> Empty import statements from non-relative modules are not allowed. Either import something specific or remove the import. */
import 'owa-pwa-utils';
import { bootstrapApolloCache } from './initialization/bootstrapApolloCache';
import { getCommonBootstrap } from './getCommonBootstrap';
import initializeNestedAppAuthExecutor from './initialization/initializeNestedAppAuthExecutor';
import type { BootstrapOptions } from './types/BootstrapOptions';

export function bootstrap(options: BootstrapOptions): Promise<any> {
    return getCommonBootstrap({
        bootstrapApolloCache,
        getBposPromise,
        getNestedAppAuthExecutorPromise: initializeNestedAppAuthExecutor,
        onComponentError: () => {
            if (isHostAppFeatureEnabled('opxComponentLifecycle')) {
                getOpxHostApi().onFatalError();
            }
        },
    })(options);
}
